import { Container } from '@chakra-ui/react';
import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';

import { DigitalLibrary } from '@/components/ui/features/researchers/DigitalLibrary/DigitalLibrary';
import { ResearchersFaq } from '@/components/ui/features/researchers/ResearchersFAQ/ResearchersFAQ';
import { ResearchersHeader } from '@/components/ui/features/researchers/ResearchersHeader/ResearchersHeader';
import { ShareYourScience } from '@/components/ui/features/researchers/ShareYourScience/ShareYourScience';
import { SubmitTodayFullWidth } from '@/components/ui/features/researchers/SubmitTodayCards/SubmitTodayFullWidth';
import { WhatDoWeOffer } from '@/components/ui/features/researchers/WhatDoWeOffer/WhatDoWeOffer';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { queryTestimonials } from '@/queries/testimonals';
import { generateStore } from '@/utils/generateStore';
import { Hydrate } from '@/utils/swr/Hydrate';

const Researchers: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ fallback }) => {
  return (
    <Hydrate fallback={fallback}>
      <Layout accessFrom={AccessFrom.Core} navigationVariant="ghost">
        <ResearchersHeader />
        <Container mt={11}>
          <DigitalLibrary />
          <WhatDoWeOffer />
          <ShareYourScience />
          <ResearchersFaq />
          <SubmitTodayFullWidth />
        </Container>
      </Layout>
    </Hydrate>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });

  await store.fetchResources(queryTestimonials());

  return {
    props: {
      fallback: store.fallback,
    },
  };
};
export default Researchers;
